import {
  FetchSiAsigContract,
  leadsConvertToClientCreateMutation,
  leadsRetrieveQueryKey
} from '@crm/api'
import { useInvalidatePredicateQueries } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { showApiErrors } from '@shared/utils'
import { useMutation } from '@tanstack/react-query'
import { App, Form, Input, Modal } from 'antd'

import type { ModalProps } from 'antd'

const formName = 'convert-to-client'

type Props = {
  leadId: number
  onClose: () => void
} & ModalProps

export const ConvertToClient = ({ leadId, onClose, ...props }: Props) => {
  const { t } = useLocales()
  const [form] = Form.useForm()
  const { notification } = App.useApp()
  const { invalidateQueries } = useInvalidatePredicateQueries()

  const { mutate, isPending } = useMutation({
    ...leadsConvertToClientCreateMutation(),
    onError: (error) => showApiErrors(error, form),
    onSuccess: (data) => {
      invalidateQueries([leadsRetrieveQueryKey({ path: { id: leadId } })])

      onClose()
      notification.success({
        message: t('success.success'),
        description: data?.message
      })
    }
  })

  const onSubmit = (values: FetchSiAsigContract) => {
    mutate({
      path: { id: leadId },
      body: values
    })
  }

  return (
    <Modal
      title={t('lead.convert_to_client')}
      cancelText={t('buttons.cancel')}
      onCancel={onClose}
      okText={t('buttons.save')}
      okButtonProps={{ htmlType: 'submit', form: formName }}
      loading={isPending}
      {...props}
    >
      <Form form={form} name={formName} onFinish={onSubmit} layout="vertical">
        <Form.Item
          name="contract_number"
          label={t('lead.contract_number')}
          rules={[{ required: true }]}
        >
          <Input placeholder={t('lead.contract_number')} />
        </Form.Item>
      </Form>
    </Modal>
  )
}
